import React, { useState, useEffect } from "react";
import validate from 'validate.js';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  Button,
  DialogActions,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  Input,
  MenuItem,
  Grid,
  Snackbar,
} from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const filter = createFilterOptions();
const EditProfileDialog = (props) => {
  const { open, close, classes, data, columns, updateProfile, memberGroups, memberTypes } = props;
  const [userData, setUserData] = useState("");
  const [value, setValue] = useState('');
  const [notValid, setNotValid] = useState('');

  const roles = [
    { display: "Admin", value: "admin-org" },
    { display: "Admin View Only", value: "admin-orgViewer" },
    { display: "User", value: "user" },
  ];
  const source = [
    "Graze Magazine",
    "Acres Magazine",
    "Narrasys",
    "Kiss The Ground Website",
    "UAg/SHA Newletter",
    "UAg/SHA Website",
    "UAg/SHA Facebook",
    "UAg/SHA Twitter",
  ];
  const organization_memberTypes = [...memberTypes];
  const organization_group = [...memberGroups];
  
  useEffect(() => {
    setUserData(data);
    setValue({
      organization_memberTypes: (data && data.organization_memberTypes) || [],
      source: (data && data.source) || [],
      organization_group: (data && data.organization_group) || [],
    });
  }, []);

  //update state for textfield input
  const handleChange = (event) => {
    console.log(event.target)
    if (Array.isArray(event.target.value)) {
      setUserData({ ...userData, [event.target.name]: event.target.value });
    } else {

        let fullName = userData.fullName;
        if (event.target.id === 'name_firstName') {
            fullName = `${event.target.value} ${userData.name_lastName}`;
        }
        if (event.target.id === 'name_lastName') {
            fullName = `${userData.name_firstName} ${event.target.value}`;
        }
        if(event.target.checked){
          console.log(userData[event.target.id], event.target.checked)
          setUserData({...userData, [event.target.id]: event.target.checked})
        } else {
          setUserData({
            ...userData,
            [event.target.id ? event.target.id : event.target.name]: event.target.value,
            ['fullName']: fullName,
          });
        }
    }
  };
  const validateForm = () =>{
    const validEmail = validate.single(userData.email, {presence: true, email: true})
    //const validPhone = validate.single(userData.phone, {presence: true, length: {minimum: 10}})
    if(validEmail === undefined) {
      updateProfile(userData, value)
    } else {
      setNotValid({email: validEmail})
      return false;
    }
  }
 
  const RenderExtensibleMenu = (props) => {
    const { column } = props;
    let options;
    if (column.id === "source") {
      options = source;
    }
    if (column.id === "organization_memberTypes") {
      options = organization_memberTypes;
    }
    if (column.id === "organization_group") {
      options = organization_group;
    }
    return (
      <Autocomplete
        value={value[column.id]}
        size="small"
        key={column.id}
        onChange={(event, newValue) => {
          console.log(newValue)
          if (typeof newValue === "string") {
            setValue({ ...value, [column.id]: newValue });
          } 
          else if (typeof newValue === 'object' && newValue !== null){
            if(newValue.length){
            let inputValueOnly = newValue.map(value => 
              typeof value !== "string" ? value.inputValue : value)
            setValue({ ...value, [column.id]: inputValueOnly });
            }else {
              setValue({ ...value, [column.id]: newValue.inputValue });
              } 
          } else {
            setValue({ ...value, [column.id]: "" });
          }
        }
        }
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          // Suggest the creation of a new value
          if (params.inputValue !== "") {
            filtered.push({
              inputValue: params.inputValue,
              title: `Add "${params.inputValue}"`})
          }
          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        multiple={column.id !== "organization_group" && column.id !== "source"}
        handleHomeEndKeys
        id={origin}
        options={options}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.title) {
              return option.title;
              }
          return ''
        }}
        style={{ width: 300 }}
        freeSolo
        renderInput={(params) => (
          <TextField {...params} label={column.label} variant="outlined" />
        )}
      />
    );
  };
  const renderTextField = () => {
    const fields = [];
    columns.forEach((column) => {
      let element = "";
      if (column.editType && column.editType === "text-field") {
        element = (
          <Grid item xs={12} sm={4}>
            <TextField
              key={column.id}
              label={column.label}
              value={userData ? userData[column.id] : ""}
              onChange={handleChange}
              id={column.id}
              fullWidth 
              helperText={notValid[column.id] || ''}
              disabled={
                column.billing &&
                userData &&
                userData.addresses_billing_sameAsMailing
              }
            />
          </Grid>
        );

        fields.push(element);
      }
      if (column.editType && column.editType === "check") {
        element = (
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                key={column.id}
                  checked={userData ? userData[column.id] : false}
                  id={column.id}
                  color="primary"
                  fullWidth
                  onChange={handleChange}
                />
              }
              label={column.label}
            />
          </Grid>
        );
        fields.push(element);
      }
      if (
        column.editType &&
        column.editType === "multi-select" &&
        column.id === "roles_0"
      ) {
        element = (
          <Grid item xs={12} sm={4}>
            <FormControl>
              <InputLabel id={column.id}>{column.label}</InputLabel>
              <Select
                labelId={column.id}
                name={column.id}
                //multiple
                fullWidth
                key={column.id}
                id={column.id}
                value={userData ? userData.roles_0 : []}
                onChange={handleChange}
                input={<Input />}
                disabled={userData && userData.roles_0 === "admin-super"}
              >
                {roles.map((role) => (
                  <MenuItem key={role} value={role.value}>
                    {role.display}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        );

        fields.push(element);
      }
      if (column.editType && column.editType === "extensible") {
        element = (
          <Grid item xs={12} sm={4}>
            <RenderExtensibleMenu origin={column.id} column={column} />
          </Grid>
        );
        fields.push(element);
      }
    });
    return fields;
  };

  const renderForm = () => {
    return (
      <Grid
        container
        direction="row"
        justify="space-evenly"
        alignItems="flex-start"
        spacing={4}
      >
        {renderTextField()}
      </Grid>
    );
  };
  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="form-dialog-title"
      fullWidth={true}
      maxWidth="xl"
    >
      <DialogTitle id="form-dialog-title">Edit Profile</DialogTitle>
      <DialogContent>{data && renderForm()}</DialogContent>
      <DialogActions>
        <Button onClick={close} >
          Cancel
        </Button>
        <Button onClick={validateForm} color="primary" variant='contained'>
          Update
        </Button>
      </DialogActions>
      <Snackbar open={notValid} autoHideDuration={6000} onClose={() => setNotValid('')}>
        <Alert onClose={() => setNotValid('')} severity="error">
          {notValid.email && `Email ${notValid.email} | `}  
        </Alert>
      </Snackbar>
    </Dialog>
  );
};
export default EditProfileDialog;
